import React, { useEffect, useState } from "react";
import "./LoginWithTwitter.css";
import TwitterLogo from "../../img/Twitter-X.png";
import { getClientInfo } from "../../util/APIUtils";
import { CLIENT, TWITTER_AUTH_URL } from "../../constants";

const LoginWithTwitter = () => {
  const [clientId, setClientId] = useState();
  const [client, setClient] = useState();
  const [uid, setUid] = useState();
  const [campaignLink, setCampaignLink] = useState();

  const [twitterLoginUrl, setTwitterLoginUrl] = useState(TWITTER_AUTH_URL);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has(CLIENT)) {
      getClientInfo(params.get(CLIENT))
        .then((response) => {
          setClient({ ...response });
          setClientId(params.get(CLIENT));
          localStorage.setItem(CLIENT, JSON.stringify(response));
          localStorage.setItem("CLIENT_ID", params.get(CLIENT));
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      const localClient = JSON.parse(localStorage.getItem(CLIENT));
      setClient(localClient);
      setClientId(localClient.clientId);
    }

    if (params.has("uid")) {
      setUid(params.get("uid"));
      setTwitterLoginUrl(
        TWITTER_AUTH_URL + `&client=${clientId}` + `&uid=${uid}`
      );
    }else if (params.has("client")) {
      setTwitterLoginUrl(
          TWITTER_AUTH_URL + `&client=${clientId}`
      );
    }

    if (params.has("campaignLink")) {
      setCampaignLink(params.get("campaignLink"));
      localStorage.setItem("campaignLink", campaignLink);
    }
  }, [uid, clientId]);

  console.log("url", twitterLoginUrl);
  return (
    <div className="signup-container">
      <div className="signup-content">
        <div className="social-signup">
          <a
            className="btn btn-block social-btn twitter"
            href={twitterLoginUrl}
          >
            <img src={TwitterLogo} alt="Twitter" /> Log in with Twitter
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginWithTwitter;



// WEBPACK FOOTER //
// ./src/user/login_with_twitter/LoginWithTwitter.js